import type React from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography, useTheme } from "@mui/material";
import { APP_PDF_FOOTER } from "consts";
import { memo, useMemo } from "react";
import getStyles from "./styles";

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).Footer, [theme]);

  return (
    <Stack component="footer" sx={styles.container}>
      <Typography component="strong">{t(`pdf_footer.${APP_PDF_FOOTER}`)}</Typography>
      {APP_PDF_FOOTER === "signify" && (
        <Typography component="small" color="textSecondary">
          {t("Calculation made with RELUX")}
        </Typography>
      )}
    </Stack>
  );
};

export default memo(Footer);
